import React from 'react';
import { UnitsTable } from './UnitsTable';
import { BarcodesTable } from './BarcodesTable';

interface UnitsAndBarcodesModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any;
  mode: 'view' | 'edit';
  onChange: (field: string, value: any) => void;
  isSupplierMode?: boolean;
  originalData?: any;
  articleNumber?: string;
}

export const UnitsAndBarcodesModal: React.FC<UnitsAndBarcodesModalProps> = ({
  isOpen,
  onClose,
  data,
  mode,
  onChange,
  isSupplierMode = false,
  originalData,
  articleNumber
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose}></div>
        
        <div className="relative bg-white rounded-xl shadow-xl w-full max-w-6xl max-h-[95vh] overflow-hidden">
          {/* Modal Header */}
          <div className="flex justify-between items-center p-6 border-b border-gray-200 bg-white sticky top-0 z-10">
            <h2 className="text-xl font-semibold text-gray-900">Einheiten und Barcodes bearbeiten</h2>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-lg"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Modal Content - Vertical Layout */}
          <div className="flex flex-col h-[80vh] overflow-hidden">
            
            {/* OBEN - EINHEITEN */}
            <div className="flex-1 min-h-0 border-b border-gray-200">
              <UnitsTable 
                data={data} 
                mode={mode}
                onChange={onChange} 
                isSupplierMode={isSupplierMode}
                originalData={originalData}
                articleNumber={articleNumber}
              />
            </div>

            {/* UNTEN - BARCODES */}
            <div className="flex-1 min-h-0">
              <BarcodesTable 
                data={data} 
                mode={mode}
                onChange={onChange} 
                isSupplierMode={isSupplierMode}
                originalData={originalData}
                articleNumber={articleNumber}
              />
            </div>
          </div>

          {/* Modal Footer */}
          <div className="flex justify-end gap-3 p-6 border-t border-gray-200 bg-white sticky bottom-0 z-10">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors font-medium"
            >
              Schließen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
